import React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '../core/SvgIcon';

const NotAnsweredIcon = ({ iconColor = '#202020', ...props }) => (
  <SvgIcon viewBox="0 0 24 24" disableStrokeColor {...props}>
    <path
      d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96452 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM20.25 12C20.2519 13.9289 19.5745 15.7969 18.3366 17.2762L6.72375 5.6625C7.92844 4.66029 9.39365 4.02191 10.9479 3.82207C12.5022 3.62223 14.0812 3.86919 15.5003 4.53406C16.9193 5.19892 18.1196 6.25418 18.9608 7.57636C19.8019 8.89854 20.2491 10.4329 20.25 12ZM3.75 12C3.74808 10.0711 4.42552 8.20306 5.66344 6.72375L17.2763 18.3375C16.0716 19.3397 14.6064 19.9781 13.0521 20.1779C11.4978 20.3778 9.91878 20.1308 8.49975 19.4659C7.08072 18.8011 5.8804 17.7458 5.03924 16.4236C4.19809 15.1015 3.7509 13.5671 3.75 12Z"
      fill={iconColor}
    />
  </SvgIcon>
);

NotAnsweredIcon.propTypes = {
  iconColor: PropTypes.string,
};

export default NotAnsweredIcon;
